import { render, staticRenderFns } from "./StudentSpecialResourceSlidebar.vue?vue&type=template&id=37ed8b84"
import script from "./StudentSpecialResourceSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentSpecialResourceSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports